export default __webpack_public_path__ + "9a2124f73d6bfb2fc1e90977a34f175f.png";